import { useAuthenticationStore } from "@twiage/view/stores/use-authentication-store";

import { defineNuxtRouteMiddleware, navigateTo } from "#imports";

const loginRoute = "/login";

export default defineNuxtRouteMiddleware((to) => {
  const authenticationStore = useAuthenticationStore();

  // If user is not authenticated and trying to access a protected route
  if (
    !authenticationStore.userTrackedPromise?.value &&
    to.path !== loginRoute
  ) {
    return navigateTo(loginRoute);
  }

  // If user is authenticated and trying to access login page
  if (authenticationStore.userTrackedPromise?.value && to.path === loginRoute) {
    return navigateTo("/");
  }
});
